import { RWaveLoader } from '@rgrd/component-library'

import styles from './PageWaveLoader.module.css'

type PageWaveLoaderProps = {
  /** The loader is `aria-hidden`, so a testid is how a test sees it at all. */
  testId?: string
}

/**
 * Full-page placeholder shown while a page is not yet ready to render, centered in the space the page
 * body leaves it.
 */
export const PageWaveLoader = ({ testId }: PageWaveLoaderProps = {}) => (
  <div className={styles.loader} aria-hidden="true" data-testid={testId}>
    <RWaveLoader />
  </div>
)
